import kitFetch from '../kit-fetch/kit-fetch';
import { itemsById } from "@kulturit/items-by-id";

export var MUSEUMS_REQUESTED = 'museums/requested';
export var MUSEUMS_RECEIVED = 'museums/received';
export var MUSEUMS_FAILED = 'museums/failed';

export var fetchMuseums = function fetchMuseums() {
    return function (dispatch) {
        fetchMuseumsPromise(dispatch).then(function (json) {
            var museumsById = itemsById(json.museums).items;
            dispatch(receiveMuseums(museumsById, json.museums));
        }).catch(function () {
            return dispatch(failMuseums());
        });
    };
};

export var fetchMuseumsPromise = function fetchMuseumsPromise(dispatch) {
    dispatch(requestMuseums());
    return kitFetch('/museum-api/museums');
};

export var requestMuseums = function requestMuseums() {
    return {
        type: MUSEUMS_REQUESTED
    };
};

export var receiveMuseums = function receiveMuseums(museumsById, museumsList) {
    return {
        type: MUSEUMS_RECEIVED,
        museums: museumsById,
        museumsList: museumsList,
        allIds: Object.keys(museumsById)
    };
};

export var failMuseums = function failMuseums() {
    return {
        type: MUSEUMS_FAILED
    };
};